export default function formatNumber(number: number = 0, intlOptions: Intl.NumberFormatOptions = {}): string {
  if (typeof Intl === 'undefined' || typeof Intl.NumberFormat === 'undefined') {
    return `${number}`;
  }
  // @ts-ignore
  const formatter = Intl.NumberFormat('en', intlOptions);
  if (!formatter || !formatter.format) return `${number}`;
  return formatter.format(number);
}
